<!-- 
    时段收费组件
    接受：是否可编辑，时段名称，默认时段值
 -->
<template>
    <el-form-item :label="label">
        <el-time-picker 
            v-model="time" is-range 
            :disabled="!isEdit" 
            range-separator="至" 
            start-placeholder="开始时间" 
            end-placeholder="结束时间" 
            placeholder="选择时间范围" 
            :index='index' 
            format='HH:mm' 
            value-format="HH:mm"
            @blur="handleTimeRange">
        </el-time-picker>
        <div style="margin-top: 12px; margin-bottom: 12px;">
            <el-form-item label="冷量单价">
                <el-input-number @change="handlePrice" v-model="coolPrice" :disabled="!isEdit" controls-position="right" :min="0" size="medium">
                </el-input-number><span> 元 / KWh</span>
            </el-form-item>
            <el-form-item label="热量单价">
                <el-input-number @change="handlePrice" v-model="hotPrice" :disabled="!isEdit" controls-position="right" :min="0" size="medium">
                </el-input-number><span> 元 / KWh</span>
            </el-form-item>
        </div>
    </el-form-item>
</template>

<script>
export default {
    name: 'TimeRange',
    props: ['isEdit', 'label','defaultValue','index', 'cool_price', 'hot_price'],
    data() {
        return {
                time: this.defaultValue,
                coolPrice: 0,
                hotPrice: 0,
        }
   },
   watch: {
       cool_price: {
            handler(val, oldVal){
                this.coolPrice = val
            },
            immediate: true
       },
       hot_price: {
            handler(val, oldVal){
                this.hotPrice = val
            },
            immediate: true
       }
   },
   components: {},
   methods: {
        // 处理工作日时间段的一些逻辑
        handleTimeRange (tag) {
            const el = tag.$options.propsData.value;
            this.time = el;
            this.handlePrice();
        },
        handlePrice() {
            this.$nextTick(() => {
                const index = this.index;
                this.$emit('listenTime', { index, time: this.time, coolPrice: this.coolPrice, hotPrice: this.hotPrice })                
            })
        }
   }
}
</script>

<style scoped>
</style>
